<template>
  <el-menu
    default-active="active"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    @select="handleSelect"
  >
    <el-submenu v-for="item in menuList" :key="item.label" :index="item.label">
      <template #title>
        <i :class="[item.label!==activeMenu ? 'el-icon-arrow-right' : 'el-icon-arrow-down'] "/>
        <span>{{ item.label }}</span>
      </template>
      <el-menu-item
        v-for="person in item.users"
        :key="person.id"
        :index="item.value + '' +person.id"
      >
        {{ person.name }}
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: "MenuSelect",
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      }
    },

  },
  data() {
    return {
      activeMenu: "",
      active: "",
      isOpen: false,
    };
  },
  mounted() {
    // console.log(this.menuList);
  },
  methods: {
    handleClose(key) {
      console.log(`关闭的是${key}`);
      this.activeMenu = "";
    },
    handleOpen(key) {
      console.log(`打开的是${key}`);
      this.activeMenu = key;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  }
};
</script>

<style scoped lang="scss">
.el-menu ::v-deep {
  .el-submenu__title {
    font-size: 16px;
    color: #333333;

    .el-submenu__icon-arrow.el-icon-arrow-down:before {
      content: "";
    }
  }

  .el-menu-item {
    font-size: 16px;
    color: #666666;
  }

  .is-opened {
    .el-submenu__title,
    .el-icon-arrow-down {
      color: #2AA5E3;
    }
  }

}
</style>
